export default "__VITE_ASSET__CUn75gUd__"